import {useEffect, useState} from 'react';
import {Box, Button, Typography} from '@mui/material';

import {AppContent, ContentRow} from '../../../styled/components';
import {ActionsRow, ContactTitleContainer, ContentRowHeader, FormRow} from './contact-title-form.styles';
import {getContactTitle} from '../api-service';

const Field = ({label, value}) => (
  <Box sx={{flex: 1, minWidth: 200}}>
    <Typography
      variant="caption"
      color="textSecondary"
      sx={{display: 'block', textTransform: 'uppercase', letterSpacing: 0.4}}
    >
      {label}
    </Typography>
    <Typography variant="body1" sx={{wordBreak: 'break-word'}}>
      {value && String(value).trim() !== '' ? value : '—'}
    </Typography>
  </Box>
);

function ContactTitleShow({titleId, onEdit, onList}) {
  const [title, setTitle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    getContactTitle(titleId)
      .then((data) => {
        if (!data) {
          throw new Error(`Contact title ${titleId} not found`);
        }
        setTitle(data);
      })
      .catch((err) => setError(err.message || 'Error loading contact title'))
      .finally(() => setLoading(false));
  }, [titleId]);

  if (loading) {
    return (
      <AppContent>
        <ContentRow>
          <Typography variant="h5" component="h1">Loading contact title...</Typography>
        </ContentRow>
      </AppContent>
    );
  }

  if (error || !title) {
    return (
      <AppContent>
        <ContentRow>
          <Typography variant="h5" component="h1" color="error">
            {error || 'Contact title not found'}
          </Typography>
        </ContentRow>
      </AppContent>
    );
  }

  return (
    <AppContent>
      <ContentRow sx={ContentRowHeader}>
        <Typography variant="h5" component="h1">{`Contact titles / ${title.name || ''}`}</Typography>
        <Box sx={ActionsRow}>
          <Button variant="outlined" onClick={onList}>Contact titles list</Button>
          <Button variant="contained" onClick={onEdit}>Edit</Button>
        </Box>
      </ContentRow>
      <ContentRow>
        <Box sx={ContactTitleContainer}>
          <Box sx={FormRow}>
            <Field label="Name" value={title.name}/>
          </Box>
        </Box>
      </ContentRow>
    </AppContent>
  );
}

export default ContactTitleShow;
